import React from "react";
import { useTranslation } from "react-i18next";
import { convertLanguageToField } from "../../../utils/functions";
import { IoAddOutline } from "react-icons/io5";
import { CategoryCard } from "../../customChallenges/cards";

import styles from "./soloCategoryCard.module.css";

export function SoloCategoryNew({ onClick, index }) {
  return (
    <div
      className={` zoom-in`}
      style={{
        "--animation-delay": `${index * 0.1}s`,
      }}
    >
      <button
        onClick={onClick}
        type="button"
        className={`${styles.new} touchable-opacity`}
      >
        <IoAddOutline size={38} />
      </button>
    </div>
  );
}

export function SoloCategoryEditCard({ category, index, onClick }) {
  const { i18n } = useTranslation();
  const title = convertLanguageToField(i18n.language, "title");

  const handleClick = () => {
    onClick(category);
  };

  return (
    <CategoryCard handleClick={handleClick} index={index}>
      <h2 className="text-lg font-bold leading-5">
        {category.custom ? category.title : category[title]}
      </h2>
    </CategoryCard>
  );
}

export default function SoloCategoryCard({ category, index, onClick }) {
  const { i18n } = useTranslation();
  const title = convertLanguageToField(i18n.language, "title");
  const descr = convertLanguageToField(i18n.language, "descr");

  const handleClick = () => {
    onClick(category);
  };

  return (
    <div
      className="zoom-in"
      style={{
        "--animation-delay": `${index * 0.1}s`,
        "--animation-duration": ".5s",
      }}
    >
      <button
        type="button"
        className={`${styles.card} ${
          styles[`card-${index}`]
        } touchable-opacity bg-black`}
        onClick={handleClick}
      >
        <h2 className="text-2xl font-bold">
          {category.custom ? category.title : category[title]}
        </h2>
        <p className="text-xs leading-3">
          {category.custom ? category.description : category[descr]}
        </p>
      </button>
    </div>
  );
}

export function SoloChallenge({ challenge, index, onClick }) {
  const handleClick = () => {
    onClick(challenge);
  };

  return (
    <div
      className={`zoom-in`}
      style={{
        "--animation-delay": `${index * 0.1}s`,
        "--animation-duration": ".5s",
      }}
    >
      <button
        onClick={handleClick}
        type="button"
        className={`${styles.challenge} touchable-opacity`}
      >
        <h2 className="text-lg font-medium leading-5">{challenge.desafio}</h2>
      </button>
    </div>
  );
}
